import styled, { css, SimpleInterpolation } from 'styled-components';

import Media from '../../../../assets/styles/media';
import THEME from '../../../../assets/styles/config';

export const DropdownCtn = styled.div`
  display: flex;
  align-items: center;

  > span {
    font-size: 16px;
    padding-right: 10px;

    ${Media.Below.tablet`
      font-size: 14px;
    `}
  }

  > div {
    width: 180px;
  }

  ${Media.Below.desktop`
    justify-content: flex-end;
  `}

  ${Media.Below.tablet`
    justify-content: flex-start;
  `}
`;

export const HeadingCtn = styled.div`
  display: flex;
  justify-content: space-between;

  ${Media.Below.desktop`
    flex-direction: column;
  `}
`;

export const HeadingDropdownCtn = styled.div`
  display: flex;
  justify-content: space-between;
  width: 60%;

  ${Media.Below.desktop`
    width: 100%;
  `}

  ${Media.Below.mobileLarge`
    flex-direction: column;
  `}

  > span {
    font-size: 30px;
    font-weight: bold;

    ${Media.Below.desktop`
      font-size: 24px;
    `}

    ${Media.Below.tablet`
      font-size: 22px;
    `}

    ${Media.Below.mobileLarge`
      font-size: 20px;
    `}
  }
`;

interface JobTypeBtnProps {
  active?: boolean;
}

// The Reports title and the Reactive / Planned toggle sit together on the left; the dropdown is at the right edge,
// level with the SLA section's dropdown below it.
export const TitleCtn = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 28px;

  > span {
    font-size: 30px;
    font-weight: bold;

    ${Media.Below.desktop`
      font-size: 24px;
    `}

    ${Media.Below.tablet`
      font-size: 22px;
    `}

    ${Media.Below.mobileLarge`
      font-size: 20px;
    `}
  }
`;

// A pill with the selected side filled in the brand colour.
export const JobTypeCtn = styled.div`
  display: inline-flex;
  padding: 3px;
  border-radius: 999px;
  background: #eaeef2;
`;

export const JobTypeBtn = styled.button<JobTypeBtnProps>`
  padding: 8px 22px;
  border: 0;
  border-radius: 999px;
  background: transparent;
  color: ${THEME.colors.primaryFontColor};
  font-family: inherit;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: background 0.2s ease-in-out, color 0.2s ease-in-out;

  ${(props): SimpleInterpolation =>
    props.active &&
    css`
      background: ${THEME.colors.primaryColor};
      color: white;
    `}

  ${Media.Below.mobileLarge`
    padding: 7px 16px;
    font-size: 12px;
  `}
`;

export const SummaryList = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 0 25px;
  margin: 50px 0 100px;

  /* Narrower than this the cards are a percentage of the row and are spread across it; at and above it they
     are a fixed size, left-aligned with a constant gap, so a wide window looks like a narrow one. */
  ${Media.Below.desktop`
    justify-content: space-between;
    gap: 0;
  `}

  ${Media.Below.tablet`
    margin: 30px 0 70px;
  `}

  ${Media.Below.mobileLarge`
    margin: 30px 0 70px;
  `}
`;

export const Empty = styled.div`
  display: none;
  flex: 0 0 14%;
  max-width: 200px;
  min-width: 190px;
  height: 0px;

  ${Media.Below.desktop`
    display: block;
    flex: 0 0 20%;
    max-width: 150px;
    min-width: 140px;
  `}

  ${Media.Below.mobileLarge`
    flex: 0 0 45%;
    max-width: 180px;
  `}
`;
